import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { Stack } from '@mui/material'
import { Box } from '@mui/material'
import React from 'react'
import { TextField } from 'src/Libs/inputs/formik'
import Select from 'src/Libs/inputs/formik/Select'
import { useAddressForm } from '../../hooks'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  spacing: {
    marginBottom: theme.spacing(3),
  },
}))

/**
 * Component for deviating installation address used in installation statement.
 * It requires formik context for the input fields.
 */
const DeviatingAddress: React.VFC = () => {
  const { deviatingAddressForm } = useAddressForm()
  const { allCountries } = useCountryOptions()
  const { classes } = useStyles()

  return (
    <Stack spacing={4}>
      <TextField
        required={deviatingAddressForm.addressAndHouseNumber.required}
        name={deviatingAddressForm.addressAndHouseNumber.name}
        label={deviatingAddressForm.addressAndHouseNumber.label}
      />
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box sx={{ width: '40%', pr: 2 }}>
          <TextField
            required={deviatingAddressForm.zipCode.required}
            name={deviatingAddressForm.zipCode.name}
            label={deviatingAddressForm.zipCode.label}
          />
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <TextField required={deviatingAddressForm.city.required} name={deviatingAddressForm.city.name} label={deviatingAddressForm.city.label} />
        </Box>
      </Box>
      <Select
        className={classes.spacing}
        required={deviatingAddressForm.country.required}
        name={deviatingAddressForm.country.name}
        label={deviatingAddressForm.country.label}
        options={allCountries}
        isSearchable
      />
    </Stack>
  )
}

export default DeviatingAddress
